/**
 * Persistent disclaimer footer. Required by SPEC.md §1 and §11.
 *
 * Do not remove or hide this. It is the project's primary mitigation
 * against trademark risk.
 */

import { html, render } from 'lit-html';

const TEXT =
  'Virtuaroo is an unofficial fan project. Not affiliated with, endorsed by, or sponsored by Bonnaroo, Superfly, or Live Nation.';

export function mountDisclaimer(): void {
  const root = document.getElementById('ui-root');
  if (!root) return;
  const container = document.createElement('div');
  container.className = 'disclaimer';
  root.appendChild(container);
  render(html`<span>${TEXT}</span>`, container);
}
